import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { CustomCard } from '../../Utils/UI/Text';
import Loader from '../../Loader/Loader';
import { Typography } from "antd";
const { Text } = Typography;

// Corrige el problema de los iconos rotos en Leaflet (común con Webpack)
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const MapLocation = ({ latitude, longitude, isLoading }) => {
    const hasData = (latitude !== undefined && latitude !== null && !isNaN(latitude)) &&
                    (longitude !== undefined && longitude !== null && !isNaN(longitude));

    return (
        <CustomCard>
            <span className="title-line-chart">Location</span>

            {isLoading ? (
                <div className="loader-container" >
                    <Loader />
                </div>
            ) : hasData ? (
                <div className="chart-container" style={{ height: '300px', width: '100%' }} >
                    <div className="chart-inner" style={{ height: '100%', width: '100%' }}>
                        <MapContainer
                            center={[latitude, longitude]} 
                            zoom={13} 
                            scrollWheelZoom={false} 
                            style={{ height: '100%', width: '100%' }} 
                        >                          
                            <TileLayer
                                attribution='Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
                                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                            />
                            <Marker position={[latitude, longitude]}>
                                <Popup>
                                    Ubicación del proyecto: <br /> Lat: {latitude}, Lng: {longitude}
                                </Popup>
                            </Marker>
                        </MapContainer>
                    </div>
                </div>
            ) : (
                <div className="no-results-container" >
                    <Text className="no-data-message">No data available</Text>
                </div>
            )}
        </CustomCard>
    );
};

export default MapLocation;